module.exports = __webpack_public_path__ + "static/img/aqzs12.a5e1b05b.jpg";